export default __webpack_public_path__ + "static/media/Icons_1.a202c8c5.svg";